import { WEBAPP_ROUTE_PREFIX } from '../../../../../constants/route'
import {
  useInitData,
  useIsExternalContactProfileNGAvailable,
  useIsProviderProfileNGAvailable,
  useIsUserProfileNGAvailable,
  useLinkLikeClick,
} from '../../../../../hooks'
import {
  MultiValuedList,
  MultiValuedListVariant,
} from '../../../../MultiValuedList'

import {
  copiedToFilterByName,
  getCopiedToTagItemProfileLink,
} from './CopiedToTagList.utils'
import { CopiedToTagListItem } from './CopiedToTagListItem'
import { CopiedToTagMoreItem } from './CopiedToTagMoreItem'

import * as styles from './CopiedToTagList.module.css'

function CopiedToTagList({
  className = styles.list,
  items,
  moreProps,
  onClickRemoveCopiedEntity,
}) {
  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const { availableSections } = useInitData()
  const isExternalContactProfileNGAvailable =
    useIsExternalContactProfileNGAvailable()
  const isProviderProfileNGAvailable = useIsProviderProfileNGAvailable()
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()

  function handleClickItem({ entity, event, id, role }) {
    const link = getCopiedToTagItemProfileLink({
      availableSections,
      entity,
      id,
      isExternalContactProfileNGAvailable,
      isProviderProfileNGAvailable,
      isUserProfileNGAvailable,
      role,
    })

    handleClick({
      event,
      link,
      // Webapp fallbacks (flat/building/staff) keep opening in a new tab.
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  function handleMouseDownItem({ entity, event, id, role }) {
    const link = getCopiedToTagItemProfileLink({
      availableSections,
      entity,
      id,
      isExternalContactProfileNGAvailable,
      isProviderProfileNGAvailable,
      isUserProfileNGAvailable,
      role,
    })

    handleMouseDown({
      event,
      link,
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  return (
    <MultiValuedList
      Item={CopiedToTagListItem}
      MoreItem={CopiedToTagMoreItem}
      className={className}
      filter={copiedToFilterByName}
      itemProps={{ onDelete: onClickRemoveCopiedEntity }}
      items={items}
      itemsProps={{ className: styles.items }}
      moreItemsProps={{
        itemProps: {
          onDelete: onClickRemoveCopiedEntity,
        },
        onClickItem: handleClickItem,
        onMouseDownItem: handleMouseDownItem,
      }}
      moreProps={{ ...moreProps, className: styles.moreButton }}
      variant={MultiValuedListVariant.Tag}
      visibleCount={null}
      onClickItem={handleClickItem}
      onMouseDownItem={handleMouseDownItem}
    />
  )
}

export default CopiedToTagList
